<confirmaciongenerica #appconfirmacion (ConfirmoUsuario)="ConfirmoUsuario($event)" [TextoSiMostrar]="'Aceptar'" [TextoNoMostrar]="'Cancelar'"></confirmaciongenerica>
<mat-progress-bar color="primary" mode="indeterminate" *ngIf="mostrarCargando"></mat-progress-bar>

<div class="row mt-5">
    <div class="d-flex justify-content-between">
        <div>
            <h2 class="titleppal">{{tituloForma}}</h2>
            <div class="line">
                <div class="line2"></div>
            </div>
        </div>
        <div class="botoncerrar">
            <a type="button" (click)="CancelarRegistro()">
                <mat-icon aria-hidden="false">close</mat-icon>
            </a>
        </div>
    </div>
    <div class="position-relative">
        <a type="button" (click)="NuevoDetalle()" *ngIf="tabItemSeleccionado === 'tabReferencias' && !editarRegistroDetalles" class="accesoAdd">
            <mat-icon>add</mat-icon>
        </a>
        <div class="col-md-12 col-lg-2 col-12 btnesmaestro" *ngIf="tabItemSeleccionado === 'tabReferencias' && editarRegistroDetalles">
            <a type="button" class="icnTable" (click)="GuardarDetalle()">
                <mat-icon>save</mat-icon>
            </a>
            <a type="button" class="icnTable" (click)="CancelarEditarDetalle()">
                <mat-icon>close</mat-icon>
            </a>
        </div>
    </div>
    <mat-tab-group class="tabcontroldatos" mat-align-tabs="start" #tabGroup (selectedTabChange)="tabSeleccionado($event)">
        <mat-tab label="tabInformacion">
            <ng-template mat-tab-label>
                <span>Información</span>
            </ng-template>
            <div [formGroup]="form" class="row pr-0 pl-0 mt-4 m-0" autocomplete="off">
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Código (*)</mat-label>
                        <input matInput formControlName="codigo" autocomplete="off" (keyup.enter)="Guardar()">
                        <mat-error *ngIf="form.get('codigo').hasError('required')">Campo requerido</mat-error>
                        <mat-error *ngIf="form.get('codigo').hasError('maxlength')">La longitud máxima es 100</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Descripción (*)</mat-label>
                        <input matInput formControlName="descripcion" autocomplete="off" (keyup.enter)="Guardar()">
                        <mat-error *ngIf="form.get('descripcion').hasError('required')">Campo requerido</mat-error>
                        <mat-error *ngIf="form.get('descripcion').hasError('maxlength')">La longitud máxima es 100</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Activo</mat-label>
                        <mat-select formControlName="activo">
                            <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaCondicionSiNo">{{item.descripcion}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="tabReferencias">
            <ng-template mat-tab-label>
                <span>Referencias</span>
            </ng-template>
            <div class="d-flex justify-content-between flex-wrap filtrosTable align-items-center" autocomplete="off" *ngIf="!editarRegistroDetalles">
                <div [formGroup]="formConsulta" class="d-flex flex-wrap" autocomplete="off">
                    <div class="p-1">
                        <mat-form-field appearance="fill">
                            <mat-label>Filtrar datos</mat-label>
                            <input matInput formControlName="filtro" autocomplete="off" (ngModelChange)="FiltrarRegistrosDetalles()">
                            <button mat-icon-button matSuffix type="button">
                                <mat-icon>search</mat-icon>
                            </button>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div class="d-flex flex-column">
                <div [formGroup]="formDetalles" class="row pr-0 pl-0 mt-4 m-0" autocomplete="off" *ngIf="editarRegistroDetalles">
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Tipo configuración (*)</mat-label>
                            <mat-select formControlName="tipoConfiguracion">
                                <mat-option [value]="item.codigo" *ngFor="let item of this.listasTipoConfiguracion">{{item.descripcion}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="formDetalles.get('tipoConfiguracion').hasError('required')">Campo requerido</mat-error>
                            <mat-error *ngIf="formDetalles.get('tipoConfiguracion').hasError('maxlength')">La longitud máxima es 20</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Tipo parámetro (*)</mat-label>
                            <mat-select formControlName="tipoParametro">
                                <mat-option [value]="item.codigo" *ngFor="let item of this.listasTipoParametro">{{item.descripcion}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="formDetalles.get('tipoParametro').hasError('required')">Campo requerido</mat-error>
                            <mat-error *ngIf="formDetalles.get('tipoParametro').hasError('maxlength')">La longitud máxima es 20</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12" *ngIf="this.MostrarBuscadorDetalleSINO()">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Parámetro configuración (*)</mat-label>
                            <mat-select formControlName="parametroConfiguracion">
                                <mat-option [value]="item.codigo" *ngFor="let item of this.listaParametrosPrograma">{{item.descripcion}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="formDetalles.get('parametroConfiguracion').hasError('required')">Campo requerido</mat-error>
                            <mat-error *ngIf="formDetalles.get('parametroConfiguracion').hasError('maxlength')">La longitud máxima es 50</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12" *ngIf="this.MostrarBuscadorDetalleSINO()">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Parámetro configuración (*)</mat-label>
                            <mat-select formControlName="valorConfiguracion">
                                <mat-option [value]="item.codigo" *ngFor="let item of this.listaCondicionParametroSiNo">{{item.descripcion}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="formDetalles.get('valorConfiguracion').hasError('required')">Campo requerido</mat-error>
                            <mat-error *ngIf="formDetalles.get('valorConfiguracion').hasError('maxlength')">La longitud máxima es 50</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="mat-elevation-z8 p-0">
                    <div class="table-responsive">
                        <table mat-table [dataSource]="dataSourceDetalles" matSort class="table table-striped table-hover">

                            <ng-container matColumnDef="id">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> ID</th>
                                <td mat-cell *matCellDef="let row"> {{row.id}} </td>
                            </ng-container>
                            <ng-container matColumnDef="tipoConfiguracion">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Tipo configuración</th>
                                <td mat-cell *matCellDef="let row"> {{row.tipoConfiguracion}} </td>
                            </ng-container>
                            <ng-container matColumnDef="tipoParametro">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Tipo parámetro</th>
                                <td mat-cell *matCellDef="let row"> {{row.tipoParametro}} </td>
                            </ng-container>
                            <ng-container matColumnDef="parametroConfiguracion">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Parámetro</th>
                                <td mat-cell *matCellDef="let row"> {{row.parametroConfiguracion}} </td>
                            </ng-container>
                            <ng-container matColumnDef="acciones">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    Acciones
                                </th>
                                <td mat-cell *matCellDef="let row, let i">
                                    <a type="button" class="icnTable" (click)="EditarDetalle(row)" *ngIf="!editarRegistroDetalles">
                                        <mat-icon>edit</mat-icon>
                                    </a>
                                    <a type="button" class="icnTable" (click)="EliminarDetalle(row)" *ngIf="!editarRegistroDetalles">
                                        <mat-icon>delete</mat-icon>
                                    </a>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="columnasEncabezadoDetalles"></tr>
                            <tr mat-row *matRowDef="let row; columns: columnasEncabezadoDetalles;"></tr>

                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell" colspan="9">No existen datos con el filtro indicado </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="fondopaginador">
                    <mat-paginator #paginatordetalles [pageSize]="10" [pageSizeOptions]="[10, 20, 30, 40, 50]" aria-label="Select page of users"></mat-paginator>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
    <div class="d-flex flex-row-reverse pr-0" *ngIf="tabItemSeleccionado === 'tabInformacion' || (tabItemSeleccionado !== 'tabInformacion' && this.form.valid)">
        <div *ngIf="this.tamanoAppService.mostrarModoEscritorio">
            <button mat-button class="botonguardardatos" (click)="Guardar()" [disabled]="mostrarCargando">
                <div class="d-flex flex-row-reverse">
                    <mat-icon class="botonguardardatosicono">check_circle_outline</mat-icon>
                    <span class="botonguardardatostexto">{{tituloBoton}}</span>
                </div>
            </button>
        </div>
    </div>
</div>